/** A category's name in the interface language: the Arabic name when the screen is Arabic and one is recorded, otherwise the name. */
export function localizedName(
  name: string,
  nameAr: string | null | undefined,
  language: string,
): string {
  return language.startsWith('ar') && nameAr ? nameAr : name;
}

/** A category as it reads in a flat list, with its parent first when it is a sub-category. */
export function categoryLabel(
  category: {
    name: string;
    nameAr: string | null;
    parentName: string | null;
    parentNameAr: string | null;
  },
  language: string,
): string {
  const own = localizedName(category.name, category.nameAr, language);
  return category.parentName
    ? `${localizedName(category.parentName, category.parentNameAr, language)} › ${own}`
    : own;
}
